<div class="block-full-width no-padding no-border-radius">
    <div class="password-recovery">
        <div class="password-recovery-items-area">
            <h2
                class="password-recovery-items-area__title"
                [ngClass]="{ 'margin-bottom-10': showRequiredText === true }">
                {{ 'EMAIL_ADDRESS' | translate }}
            </h2>
            <p class="required-text" *ngIf="showRequiredText">{{ 'REQUIRED_FIELDS_FORM_TITLE' | translate }}</p>

            <form [formGroup]="emailForm" (ngSubmit)="submit()">
                <ridango-form-field class="form-margin-10">
                    <input
                        [formControl]="emailForm.controls.email"
                        [attr.aria-label]="'LOCAL_LABEL_EMAIL' | translate"
                        ridangoInput
                        type="email"
                        ridangoUntouchOnFocusout
                        name="email"
                        required />
                    <ridango-label>{{ 'PH_EMAIL' | translate }}</ridango-label>
                    <ridango-error
                        *ngIf="emailForm.controls.email.touched && emailForm.controls.email.hasError('required')">
                        {{ 'FIELD_VALIDATION_REQUIRED' | translate }}
                    </ridango-error>
                    <ridango-error
                        *ngIf="emailForm.controls.email.touched && emailForm.controls.email.hasError('email')">
                        {{ 'EMAIL_NOT_VALID' | translate }}
                    </ridango-error>
                </ridango-form-field>
                <button
                    class="btn btn--maximal btn--primary btn--big gl-light:text-[var(--color-primary)]"
                    [disabled]="loading$ | async"
                    type="submit">
                    {{ 'BUTTON_NEXT' | translate }}
                </button>
            </form>
        </div>
    </div>
</div>
